import {obtenerIndicativoPais} from "./obtenerIndicativoPais";
import {limpiarNumero} from "./limpiarNumero";

export const iniciarChatWass = ({numero, mensaje='', pais=null, local=true}) => {


    let indicativo = obtenerIndicativoPais(pais);
    if (local){
        indicativo = '57'
    }
    let numeroLimpio = limpiarNumero(numero)

    let texto = encodeURI(mensaje)
    let link = `https://api.whatsapp.com/send?phone=${indicativo}${numeroLimpio}&text=${texto}`
    window.open(link)

}